module.exports = __webpack_public_path__ + "img/jht-icon-13-act.9541b3c2.png";